import { Navigate, Outlet } from 'react-router-dom';
import type { Role } from '@ctp/shared';
import { useAuth } from '../auth/AuthContext';
import { Layout } from './Layout';
import { PageLoader } from './ui';

/** Schützt Routen: kein Token → /login; falsche Rolle → /forbidden (SEC-Z1, UX-Ebene). */
export function ProtectedRoute({ roles }: { roles?: Role[] }): JSX.Element {
  const { token, user, loading } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  if (loading || !user) {
    return (
      <Layout>
        <PageLoader />
      </Layout>
    );
  }
  if (roles && !roles.includes(user.role)) return <Navigate to="/forbidden" replace />;
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
